import React, { Component } from 'react';
import './Styles/Input.css';

export default class Input extends Component {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        let { onChange } = this.props;
        let value = event.target.value;
        if(onChange) {
            onChange(value);
        }
    }



    render() {

        let { value, label, type, className, disabled } = this.props;

        return <div className={`input ${className}`}>
            {/* <div className="input-label">{label}</div> */}
            <input disabled={disabled} type={type || "text"} placeholder={label} value={value || ""} onChange={this.onChange} />
        </div>



    }

}